"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkSearchBotForAB = exports.checkBrowserSupportForWebChat = void 0;
/* istanbul ignore file -- no need to test exports */
__exportStar(require("./extraction"), exports);
var webchatBrowserSupportUtil_1 = require("./webchatBrowserSupportUtil");
Object.defineProperty(exports, "checkBrowserSupportForWebChat", { enumerable: true, get: function () { return webchatBrowserSupportUtil_1.checkBrowserSupportForWebChat; } });
Object.defineProperty(exports, "checkSearchBotForAB", { enumerable: true, get: function () { return webchatBrowserSupportUtil_1.checkSearchBotForAB; } });
//# sourceMappingURL=index.js.map